import { IApp } from "@/interfaces";
import { LanguageKey } from "@/store/modules/common/interfaces";
import { DigitalHumanSetting } from "@/store/modules/digital_human/interfaces";
import { clean_string } from "./global";

const isCore42Portal =
  clean_string(process.env.VUE_APP_PORTAL) ===
  clean_string(IApp.Portals.COREHCMS);

const logo_config: any = {
  [IApp.Portals.COREHCMS]: require("@/assets/logos/core42-hcms-white.png"),
  [IApp.Portals.INCEPTION]: require("@/assets/logos/inception-hcms-green.png"),
  [IApp.Portals.GRAND_MOSQUE]: require("@/assets/logos/grand_mosque.png"),
  [IApp.Portals.ADA]: require("@/assets/logos/adalogo.png")
};

const digital_human_setting: Record<string, DigitalHumanSetting> = {
  [IApp.Portals.AI_LAWYER]: {
    welcome_message:
      "Hello I am Adele, a lawyer specializing in cyber laws in the UAE region. I have extensive knowledge and experience in dealing with legal matters related to personal data protection, electronic documents, and the identification of individuals through various means. I am committed to helping my clients navigate the complex legal landscape in the digital age.",
    bot_avatar: "Kayla-incasualsuit-20220818",
    bot_voice_id: "8273e0a033074b5bb98d7ce3ab727bd9",
    intro_popup: {
      title: "AI Lawyer",
      message:
        'Hello I am Adele, a lawyer specializing in cyber laws in the UAE region. Please click <span class="font-weight-bold">Continue</span> to chat with me.'
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: require("@/assets/logos/core42-hcms-white.png"),
    reset_chat_history: false,
    width: "",
    height: ""
  },
  [IApp.Portals.AI_BOARD_MEMBER]: {
    welcome_message:
      "Hello, I'm Aiden, a board member at META Corporation. I leverage my extensive experience and expertise to offer valuable insights and guidance, aiding in the company's strategic direction and success.",
    bot_avatar: "Tyler-insuit-20220721",
    bot_voice_id: "e17b99e1b86e47e8b7f4cae0f806aa78",
    intro_popup: {
      title: "AI Board Members",
      message:
        'Hello, I am Aiden, a male board member at META corporation. Please click <span class="font-weight-bold">Continue</span> to chat with me.'
    },
    members: [],
    logo: require("@/assets/logos/core42-hcms-white.png"),
    reset_chat_history: false,
    width: "",
    height: ""
  },
  [IApp.Portals.AL_MUFTI]: {
    welcome_message:
      "Assalamu Alaikum! I'm your AI Mufti for Islamic Fatwas in the UAE. Ask me anything about Islamic law and practices here in the Emirates!",
    bot_avatar: "Tyler-insuit-20220721",
    bot_voice_id: "e17b99e1b86e47e8b7f4cae0f806aa78",
    intro_popup: {
      title: "Al Mufti",
      message:
        "Assalamu Alaikum! I'm your AI Mufti for Islamic Fatwas in the UAE. Ask me anything about Islamic law and practices here in the Emirates!"
    },
    members: [],
    language: LanguageKey.ARABIC,
    logo: require("@/assets/logos/core42-hcms-white.png"),
    reset_chat_history: false,
    width: "",
    height: ""
  },
  [IApp.Portals.FINANCE_MANAGER]: {
    welcome_message:
      "Hello! I'm your AI CEO Office Virtual Assistant. Ask me anything about Financial Benchmarking",
    bot_avatar: "eb0a8cc8046f476da551a5559fbb5c82",
    bot_voice_id: "", //e17b99e1b86e47e8b7f4cae0f806aa78
    intro_popup: {
      title: "AI CEO Office Virtual Assistant",
      message:
        "Hello! I'm your AI CEO Office Virtual Assistant. Ask me anything about Financial Benchmarking"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: !isCore42Portal ? "200" : "130",
    height: !isCore42Portal ? "200" : "130"
  },
  [IApp.Portals.DIGITAL_HUMAN]: {
    welcome_message:
      "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!",
    bot_avatar: "c20f4bdddbe041ecba98d93444f8b29b",
    bot_voice_id: "aa815b9a80534d928634cb7df4f99754",
    intro_popup: {
      title: "AI HR Office Assistant",
      message:
        "Hello! I'm your AI HR Office Assistant. I'm here to support you with all your HR queries. Feel free to ask me anything about employee management, recruitment, or company policies!"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: !isCore42Portal ? "200" : "130",
    height: !isCore42Portal ? "200" : "130"
  },
  [IApp.Portals.AI_TRAINER]: {
    welcome_message:
      "Hi! I am AI-Trainer, here to assist you in learning new skills and provide training across diverse subjects and fields. Let's embark on a journey of knowledge and growth together!?",
    bot_avatar: "Tyler-insuit-20220721",
    bot_voice_id: "e17b99e1b86e47e8b7f4cae0f806aa78",
    intro_popup: {
      title: "AI-Trainer Assistant",
      message:
        "Hi! I am AI-Trainer, here to assist you in learning new skills and provide training across diverse subjects and fields. Let's embark on a journey of knowledge and growth together!?"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: !isCore42Portal ? "200" : "130",
    height: !isCore42Portal ? "200" : "130"
  },
  [IApp.Portals.GRAND_MOSQUE]: {
    welcome_message:
      "Hi, I am your AI Visitor Assistant for the Sheikh Zayd Grand Mosque. I'm here to answer your questions and provide you with valuable information about the mosque, its history, and proper etiquette during your visit. Feel free to ask me anything!",
    bot_avatar: "Tyler-insuit-20220721",
    bot_voice_id: "e17b99e1b86e47e8b7f4cae0f806aa78",
    intro_popup: {
      title: "AI Visitor Assistant",
      message:
        "Hi, I am your AI Visitor Assistant for the Sheikh Zayd Grand Mosque. I'm here to answer your questions and provide you with valuable information about the mosque, its history, and proper etiquette during your visit. Feel free to ask me anything!"
    },
    members: [],
    language: LanguageKey.ENGLISH,
    logo: logo_config[process.env.VUE_APP_PORTAL],
    reset_chat_history: true,
    width: !isCore42Portal ? "200" : "130",
    height: !isCore42Portal ? "200" : "130"
  }
};

export default digital_human_setting;
